import { apiUrl, apiHost } from './apiurl';
import { ConvertToCSV, decryptUserToken } from './index';
import {  formatDateTime } from '../Components/Common/TimeStamp';
import { ClearAutoLogout, AutoLogout } from './AutoLogout';
import { UsersFields } from 'models/Users.model'
import { authHeader } from '../Helpers/index';

export const getUsers = (url, signal) => {
    const URL = `${ apiUrl }/admin${ url }`;
    return fetch(URL, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            ...authHeader()
        },
        signal: signal
    })
}

export const getUserInfo = (url) => {
    const URL = `${ apiUrl }/admin${ url }`;
    return fetch(URL, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

let ExportData = [];

const exportCsv = (fileName) => {
    const csvSupportedFormat = ConvertToCSV(JSON.stringify(ExportData));
    const csvContent = 'data:text/csv;charset=utf-8,' + csvSupportedFormat;
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', fileName);
    document.body.appendChild(link); // Required for FF
    link.click(); // This will download the csv file.
    AutoLogout();
}

export const exportUsersData = (url, page, size, header, fileName, exportUsersStatus, reset, isAuth = false) => {
    ClearAutoLogout();
    if(reset) ExportData = [ ...header ];
    const fetchUrl = `${ apiUrl }/admin${ url }?page=${ page }&size=${ size }`;
    const headers = {
        'Content-Type': 'application/json'
    };
    if (isAuth) headers[ 'Authorization' ] = decryptUserToken();
    fetch(fetchUrl, {
        method: 'GET',
        headers,
    })
    .then(response => response.json())
    .then( res => {
        console.log('response', res);
        const { data: resData = [] } = res;
        const data = resData.map(function(res){
            const obj = {};
            const registeredAt = formatDateTime(res[ UsersFields.registeredAt ]);
            obj[ 'Name' ] = res[ UsersFields.name ];
            obj[ 'Email' ] = res[ UsersFields.emailId ];
            obj[ 'Registered Date' ] = registeredAt && registeredAt;
            const deviceType = res[ UsersFields.deviceType ] === '' || res[ UsersFields.deviceType ] === null ? 'web' : res[ UsersFields.deviceType ];
            const deviceVersion = (deviceType !== 'web' && res[ UsersFields.deviceVersion ]) ? (' ' + res[ UsersFields.deviceVersion ]) : '';
            obj[ 'Device Type' ] = deviceType + deviceVersion;
            return obj;
        });
        const csvData = ExportData;
        ExportData = [
            ...csvData,
            ...data
        ]
        if(data.length !== 0) {
            exportUsersData(url, page + 1, size, header, fileName, exportUsersStatus, 0)
        }else if(data.length === 0 || data.length < size) {
            exportUsersStatus('Export To CSV')
            exportCsv(fileName);
        }
    })
    .catch((error) => {
        AutoLogout();
        console.log('error', error)
    });
}

export const wipeUserData = (url) => {
    const URL = `${ apiUrl }/admin${ url }`;
    return fetch(URL, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export const inviteUser = (emailList) => {
    return fetch(`${ apiUrl }/users/invite/emailinvite`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(
            {
                'emailIds': emailList
            }
        ),
    })
    
}
